var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo__icon",attrs:{"src":require("../assets/pastorius-logo.png"),"width":"50","height":"50","alt":"Pastorius"}}),_vm._v(" "),_c('div',{staticClass:"logo__brand"},[_vm._v("Pastorius")]),_vm._v(" "),_c('div',{staticClass:"logo__title"},[_vm._v("Lifestyle management")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f93978","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 38
// module chunks = 0